// removed by extract-text-webpack-plugin
module.exports = {"categoriesMobile":"twgaKrjAmTvEvSpMBrsxR","catItem":"_2wEa0R3pKE6XPs_grPFOS_","catIcon":"_1p7VwXn8TIH5Cu8UDBw_96","massageIcon":"_39Iz0RL1Qz6HlpUrXmL3R6","tatooIcon":"mT6j4_xetAB0W5FZrILN3","fitnessIcon":"_1L83WYbPbebRzZkYbSHVKs","hairIcon":"_1UyXChugRaa6TArGNW1suX","cosmeticIcon":"_2cQgd6ubhiyc7h9bl_tyeD","clinicIcon":"_2cI6hHh6A_Ulc7ubcaRCSU"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Mobile/Home/CategoriesMobile.scss
// module id = 1139
// module chunks = 0